import { Box, Skeleton } from '@inflearn/ds-react-next';

export default function PostSkeletonItem({ count }: { count?: number }) {
  if (count) {
    return (
      <>
        {Array.from({ length: count })
          .fill(1)
          .map((_, i) => (
            <Box py={16} key={i}>
              <Skeleton w={60} h={21} radius="sm" />
              <Skeleton w={570} h={26} radius="sm" mt={2} maw="100%" />
              <Skeleton w={100} h={21} radius="sm" mt={16} />
            </Box>
          ))}
      </>
    );
  }

  return (
    <Box py={16}>
      <Skeleton w={60} h={21} radius="sm" />
      <Skeleton w={570} h={26} radius="sm" mt={2} maw="100%" />
      <Skeleton w={100} h={21} radius="sm" mt={16} />
    </Box>
  );
}
